import { styled } from '@mui/material/styles';

const Form = styled('form')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(1),
}));

export default Form;
